
module dgLogger {
    declare var JL: any;
    class DgLogService implements ng.ILogProvider, ng.IServiceProvider {
        //public static $inject = ['$window'];
        public constructor() {
            this.$get.$inject = ['$window'];
        }

        public debugEnabled(enabled?: boolean): any {
            if (angular.isDefined(enabled)) {
                return this;
            } else {
                return true;
            }
        }

        public $get($window: ng.IWindowService) {
            var self = this;
            function consoleLog(type: string): Function {
                var console = $window.console || {},
                    logFn = console[type] || console['log'] || angular.noop,
                    hasApply = false,
                    JLLoggerName = 'Angular',
                    JLFunc = JL(JLLoggerName)[type == 'debug' ? 'trace' : type];

                // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
                // The reason behind this is that console.log has type "object" in IE8...
                try {
                    hasApply = !!logFn.apply;
                } catch (e) { }

                if (hasApply) {
                    return function () {
                        var args = [];
                        angular.forEach(arguments, function (arg) {
                            args.push(formatError(arg));
                        });
                        JLFunc.apply(JL(JLLoggerName), args)
                        return logFn.apply(console, args);
                    };
                } else {
                    return function () {
                        var args = [];
                        angular.forEach(arguments, function (arg) {
                            args.push(formatError(arg));
                        });
                        JLFunc.apply(JL(JLLoggerName), args)
                    };
                }
            }

            function formatError(arg) {
                if (arg instanceof Error) {

                    if (arg.stack) {
                        arg = (arg.message && arg.stack.indexOf(arg.message) === -1)
                        ? 'Error: ' + arg.message + '\n' + arg.stack
                        : arg.stack;
                    } else if (arg["sourceURL"]) {
                        arg = arg["message"] + '\n' + arg["sourceURL"] + ':' + arg["line"];
                    }
                }
                return arg;
            }
            
            return {
                log: consoleLog('log'),
                info: consoleLog('info'),
                warn: consoleLog('warn'),
                error: consoleLog('error'),
                debug: (function () {
                    var fn = consoleLog('debug');

                    return function() {
                        if (self.debugEnabled()) {
                            fn.apply(this, arguments);
                        }
                    };
                } ())
            };
        }
    }


    angular.module('dgLogger')
        .provider('$log', DgLogService);
}